import { render, staticRenderFns } from "./StatisticCardVerticalTotal.vue?vue&type=template&id=7c6dc453&"
import script from "./StatisticCardVerticalTotal.vue?vue&type=script&lang=js&"
export * from "./StatisticCardVerticalTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports